import { getNearestSvgNode } from './element';

const WIDTH = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
const HEIGHT = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

const BUGGED_SVG_ELEMENTS_IO = [SVGForeignObjectElement];

const getViewportPosition = target => {
  if (target instanceof Element) {
    const SVG = getNearestSvgNode(target, SVGGraphicsElement, BUGGED_SVG_ELEMENTS_IO);

    if (SVG) {
      const { element, root } = SVG;

      const leftPoint = root.createSVGPoint();
      const rightPoint = root.createSVGPoint();

      const { x, y, height, width } = element.getBBox();

      leftPoint.x = x;
      leftPoint.y = y;

      rightPoint.x = x + width;
      rightPoint.y = y + height;

      const matrix = element.getScreenCTM();

      const { x: left, y: top } = leftPoint.matrixTransform(matrix);
      const { x: right, y: bottom } = rightPoint.matrixTransform(matrix);

      return { left, right, top, bottom, width: right - left, height: bottom - top };
    }

    return target.getBoundingClientRect();
  }

  return {};
};

export const VIEWPORT = {
  WIDTH,
  HEIGHT,
  getViewportPosition
};
